import { useState } from "react";

import iPlus from "../../assets/images/Plus.svg";
import ToggleButton from "../ToggleButton";

import SingleParticipant from "./SingleParticipant";
import SingleVideoParticipant from "./SingleVideoParticipant";

const VideoMeeting = () => {
  const [email, setEmail] = useState(15);
  const [countParticipants, setCountParticipants] = useState(5);
  const [showAllParticipants, setShowAllParticipants] = useState(false);
  return (
    <div className="video-meeting">
      <div className="video-meeting-users">
        <div className={`video-participants-contaner n${countParticipants}`}>
          {Array.from(Array(+countParticipants), (_, i) => (
            <SingleVideoParticipant index={i} />
          ))}
        </div>
      </div>
      <div
        className="dev-mode"
        style={{
          position: "absolute",
          width: "200px",
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          top: "100px",
          left: "50%",
          padding: "20px",
          borderRadius: "10px",
        }}>
        <strong>Participants (2-9) </strong>
        <br />
        <input type="number" value={countParticipants} className="fg w-30" onChange={(e) => setCountParticipants(e.target.value)} />
      </div>
      <div className="video-meeting-sidebar">
        <div className="flex m-b-24">
          <span className="B1-SemiBold m-r-8 fg-text-white">Participants</span>
          <div className="circle-count C1-SemiBold i-18 gray">
            <span>10</span>
          </div>
        </div>
        <div className="h-100p relative">
          <div className="B2-Medium m-b-9 fg-text-gray-light2">Add New</div>
          <div className="bb-gray-4000 p-r-32">
            <input
              type="number"
              placeholder="e.g. John"
              id="email"
              className={`fg dark-mode ${!email && "error"}`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <span className={`input-error ${email.length > 0 && "visibility-hidden"}`}>This field can't be empty-item</span>
            <div className="align-items-center space-between m-tb-6 p-b-8">
              <div className="align-items-center">
                <ToggleButton withIcon darkMode />
                <span className="B3-Medium fg-text-gray-light2 m-l-10"> Manage Meeting </span>
              </div>
              <div className="button button-sm button-bk">
                <img alt="" src={iPlus} />
                <span>ADD</span>
              </div>
            </div>
          </div>
          <div className={`video-meeting-sidebar-list-users ${showAllParticipants && email > 6 && "show-all"} `}>
            <SingleParticipant state="add-success" />
            <SingleParticipant state="removed" />
            <SingleParticipant isGroup />

            {Array.from(Array(+email)).map(() => (
              <SingleParticipant />
            ))}
          </div>
          {email > 6 && !showAllParticipants && (
            <div className="button-show-all" onClick={() => setShowAllParticipants(!showAllParticipants)}>
              <div className="B3-Medium fg-text-white">Show All Participants</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoMeeting;
